export const siteInspectionFormInitialValues = {
  venue_name: "",
  inspection_date: "",
  inspection_time: "",
  inspection_category: "",
};
